import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { DisplayFlex } from '../commonStyles';
import TooltipComponent from '../Info/Tooltip/TooltipComponent';
import formatter from '../../utils/formatter';
import {
  InvestmentCard,
  CardHeading,
  CardBalance,
  YTDPercentage,
} from './styles';
import upCaret from '../../assets/icons/caret-t.svg';
import downCaret from '../../assets/icons/caret-b.svg';
import { GeneralButton } from '../Commons/commonComponents';

export function calculateFont(balanceText) {
  let fontClass = null;
  let balance = parseFloat(balanceText).toString().length;
  switch (true) {
    case balance >= 10:
      fontClass = 'small-text';
      break;
    case balance >= 7 && balance < 10:
      fontClass = 'medium-text';
      break;
    default:
      fontClass = 'large-text';
      break;
  }
  return fontClass;
}

export default function BalanceCards(props) {
  return props.config.map((obj, index) => (
    <InvestmentCard data-test="balanceCard" key={obj.heading}>
      <DisplayFlex>
        <CardHeading grantsFlag={props.grantsDashboard}>
          {obj.heading}
          <TooltipComponent placement={props.placement} text={obj.text} />
        </CardHeading>
      </DisplayFlex>
      <DisplayFlex>
        <CardBalance className={calculateFont(obj.balance)}>
          {obj.balance ? (
            <> {formatter({ value: obj.balance, fieldSuffix: 'Dollars' })}</>
          ) : (
            <>
              {'$' +
                Number(obj.balance ? obj.balance : 0).toLocaleString(
                  undefined,
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )}
            </>
          )}
        </CardBalance>
        {obj.ytdPercentage !== undefined ? (
          <DisplayFlex>
            <CardBalance className={calculateFont(obj.balance)}>(</CardBalance>
            <YTDPercentage className={calculateFont(obj.balance)}>
              {obj.ytdPercentage}%
              {obj.ytdPercentageIncrease ? (
                <img src={upCaret} alt='arrow-raise' />
              ) : (
                <img src={downCaret} alt='arrow-down' />
              )}
            </YTDPercentage>
            <CardBalance className={calculateFont(obj.balance)}>)</CardBalance>
          </DisplayFlex>
        ) : (
          ''
        )}
      </DisplayFlex>
      {obj.buttonName === 'View transaction summary' && obj.buttonName && (
        <div>
          {obj.comingSoon ? (
            <span className='tool-tip'>
              <span className='tool-tip' tabIndex='0' title={''}>
                <GeneralButton
                 data-test="GeneralButtonComingSoon"
                  onClick={(e) => props.clicked(e, obj.url, '', obj.pageName)}
                  text={obj.buttonName}
                  styling='balance-cards'
                  type='tertiary'
                  id={obj.id && obj.id + index}
                />
              </span>
              <span>
                <span className='tooltiptext-i'>Coming Soon...</span>
              </span>
            </span>
          ) : (
            <span className='tool-tip' tabIndex='0' title={''}>
              <GeneralButton
                onClick={(e) => props.clicked(e, obj.url, '', obj.pageName)}
                text={obj.buttonName}
                data-test="GeneralButton"
                type='tertiary'
                styling='balance-cards'
                id={props.id + index}
              />
            </span>
          )}
        </div>
      )}
      {obj.buttonName !== 'View transaction summary' && obj.buttonName && (
        <Link to={obj.url}>
          {obj.comingSoon ? (
            <span className='tool-tip'>
              <span className='tool-tip' tabIndex='0' title={''}>
                <GeneralButton
                   data-test="GeneralTransactionButtonComingSoon"
                  onClick={(e) => props.clicked(e, obj.url, '', obj.pageName)}
                  text={obj.buttonName}
                  styling='balance-cards'
                  id={props.id + index + 'link'}
                  type='tertiary'
                />
              </span>
              <span>
                <span className='tooltiptext-i'>Coming Soon...</span>
              </span>
            </span>
          ) : (
            <span className='tool-tip' tabIndex='0' title={''}>
              <GeneralButton
                data-test="GeneralTransactionCards"
                onClick={(e) => props.clicked(e, obj.url, '', obj.pageName)}
                text={obj.buttonName}
                styling='balance-cards'
                id={obj.id && obj.id + index}
                type='tertiary'
              />
            </span>
          )}
        </Link>
      )}
    </InvestmentCard>
  ));
}

BalanceCards.propTypes = {
  clicked: PropTypes.func,
  config: PropTypes.obj,
  grantsDashboard: PropTypes.any,
  id: PropTypes.any,
  placement: PropTypes.any,
};
